/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessObjectFormatExternalInterfaceDescriptiveInformation } from '../model/businessObjectFormatExternalInterfaceDescriptiveInformation';
import { ErrorInformation } from '../model/errorInformation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class BusinessObjectFormatExternalInterfaceDescriptiveInformationService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * getBusinessObjectFormatExternalInterface
     * Retrieves the existing business object format external interface descriptive information based on the specified parameters.
     * @param namespace the namespace
     * @param businessObjectDefinitionName the business object definition name
     * @param businessObjectFormatUsage the business object format usage
     * @param businessObjectFormatFileType the business object format file type
     * @param externalInterfaceName the external interface name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, externalInterfaceName: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessObjectFormatExternalInterfaceDescriptiveInformation>;
    public businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, externalInterfaceName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessObjectFormatExternalInterfaceDescriptiveInformation>>;
    public businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, externalInterfaceName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessObjectFormatExternalInterfaceDescriptiveInformation>>;
    public businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface(namespace: string, businessObjectDefinitionName: string, businessObjectFormatUsage: string, businessObjectFormatFileType: string, externalInterfaceName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface.');
        }
        if (businessObjectDefinitionName === null || businessObjectDefinitionName === undefined) {
            throw new Error('Required parameter businessObjectDefinitionName was null or undefined when calling businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface.');
        }
        if (businessObjectFormatUsage === null || businessObjectFormatUsage === undefined) {
            throw new Error('Required parameter businessObjectFormatUsage was null or undefined when calling businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface.');
        }
        if (businessObjectFormatFileType === null || businessObjectFormatFileType === undefined) {
            throw new Error('Required parameter businessObjectFormatFileType was null or undefined when calling businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface.');
        }
        if (externalInterfaceName === null || externalInterfaceName === undefined) {
            throw new Error('Required parameter externalInterfaceName was null or undefined when calling businessObjectFormatExternalInterfaceDescriptiveInformationGetBusinessObjectFormatExternalInterface.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BusinessObjectFormatExternalInterfaceDescriptiveInformation>(`${this.configuration.basePath}/businessObjectFormatExternalInterfaceDescriptiveInformation/namespaces/${encodeURIComponent(String(namespace))}/businessObjectDefinitionNames/${encodeURIComponent(String(businessObjectDefinitionName))}/businessObjectFormatUsages/${encodeURIComponent(String(businessObjectFormatUsage))}/businessObjectFormatFileTypes/${encodeURIComponent(String(businessObjectFormatFileType))}/externalInterfaceNames/${encodeURIComponent(String(externalInterfaceName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
